import { useState, useEffect, useRef } from 'react'

export default function OpenSourceLicenses() {
  return (
    <iframe
      src={`/htm/open-source-licenses.html`}
      style={{ width: '100vw', height: '100vh', border: 'none' }}
    ></iframe>
  )
}
